import * as FlowTypes from 'automation-ui-canvas/flow/constants/FlowTypes';
const ACTION_SET = 'action-set';
const WORKFLOW = 'edit';
export const getScreenForFlowType = flowType => {
  switch (flowType) {
    case FlowTypes.ACTION_SET:
      return ACTION_SET;
    case FlowTypes.WORKFLOW:
    default:
      return WORKFLOW;
  }
};